import css from './Container.module.css';

import {
  Alignment,
  Display,
  DisplayFlexDirection,
  Spacing,
} from '../../../types/appTypes';
import React from 'react';
import { LayoutUtil } from '../../../utility/layoutUtil';

type ContainerProps = {
  alignment?: Alignment;
  margin?: Spacing[];
  padding?: Spacing[];
  display?: Display;
  flexDirection?: DisplayFlexDirection;
  secondaryClass?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
};

const Container = ({
  alignment,
  margin,
  padding,
  display,
  flexDirection,
  secondaryClass,
  children,
  style,
}: ContainerProps) => {
  const containerClass =
    display === undefined
      ? css.containerInlineBlock
      : css[`container${Display[display]}`];
  let classes: string[] = [containerClass];

  // flex direction
  if (display === Display.Flex) {
    classes.push(
      flexDirection === undefined
        ? css.flexRow
        : css[`flex${DisplayFlexDirection[flexDirection]}`]
    );
  }

  // alignment
  switch (alignment) {
    case Alignment.Start:
      classes.push(css.alignStart);
      break;
    case Alignment.End:
      classes.push(css.alignEnd);
      break;
    case Alignment.Center:
      classes.push(css.alignCenter);
      break;
  }

  // margin
  const marginClasses = LayoutUtil.spacingToCss('margin', margin, css);
  if (marginClasses.length > 0) classes.push(marginClasses);

  // padding
  const paddingClasses = LayoutUtil.spacingToCss('padding', padding, css);
  if (paddingClasses.length > 0) classes.push(paddingClasses);

  // secondary class
  if (secondaryClass !== undefined) classes.push(secondaryClass);

  return <span className={classes.join(' ')} style={style}>{children}</span>;
};

export default Container;
